export class TimerService {
  private static instance: TimerService;
  private startTime: number;
  private listeners: Set<(time: number) => void>;
  private intervalId: NodeJS.Timeout | null = null;

  private constructor() {
    this.startTime = Date.now();
    this.listeners = new Set();
    this.startTicker();
  }

  public static getInstance(): TimerService {
    if (!TimerService.instance) {
      TimerService.instance = new TimerService();
    }
    return TimerService.instance;
  }

  public getStartTime(): number {
    return this.startTime;
  }

  public subscribe(callback: (time: number) => void): void {
    this.listeners.add(callback);
    // Immediately invoke with current state
    callback(Date.now());
  }

  public unsubscribe(callback: (time: number) => void): void {
    this.listeners.delete(callback);
  }

  private startTicker(): void {
    if (this.intervalId) return;

    this.intervalId = setInterval(() => {
      const now = Date.now();
      for (const listener of this.listeners) {
        listener(now);
      }
    }, 1000);
  }

  public reset(): void {
    this.startTime = Date.now();
  }
}
